import {useViewer} from '../hooks/auth';
import {PortalsList} from '../types/auth';

export type permissionsList = {
  haveSettings?: boolean;
  isSuperAdmin?: boolean;
  notificiationsAccess?: boolean;
};

export const getPermissions = (): permissionsList => {
  const user = useViewer();
  return {
    haveSettings: !!user?.roles?.find((el) => el === 'SUPER ADMIN'),
    isSuperAdmin: !!user?.roles?.find((el) => el === 'SUPER ADMIN'),
    notificiationsAccess: !!user?.portals?.find((el) => el?.toLowerCase() === PortalsList.notificiations.toLowerCase()),
  };
};
